import "../../util/yup-locale";
import React from "react";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import { MemorialPage } from "../../features/undertaker-plus/memorial-page";

const elements = document.getElementsByTagName("memorial-page");

if (elements.length > 0) {
  (async () => {
    for (let i = 0; i < elements.length; i++) {
      const element = elements.item(i) as HTMLElement;
      const root = createRoot(element);
      root.render(
        <Sentry.ErrorBoundary
          fallback={
            <p>
              Der opstod en kritisk fejl. Genindlæs siden og prøv igen, eller
              kontakt support for hjælp.
            </p>
          }
        >
          <MemorialPage
            csrf={element.dataset.csrf!}
            siteId={element.dataset.siteid!}
          />
        </Sentry.ErrorBoundary>
      );
    }
  })();
}
